import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
import Textbox from '../Misc/Forms/Inputs/Textbox/Textbox';
const Label = styled.label `
  display: block;
  ${fonts.ubuntu.bold}
  font-size: ${fluid(16, 20)};
  line-height: 1.5em;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
  color: var(--fgColor);
  max-width: 1024px;

  .secondary-4 &,
  .secondary-5 &,
  .tertiary-4 & {
    color: ${brand.global.black};
  }
`;
const Container = styled.div `
  --inputHeight: 46px;

  position: relative;

  &[data-search-banner='true'] {
    --inputHeight: ${fluid(56, 66)};

    max-width: 1024px;
    margin-bottom: 20px;
  }
`;
const Input = styled(Textbox) `
  --placeholderColour: var(--fgColor);

  height: var(--inputHeight);
  max-width: calc(100% - var(--inputHeight));
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;

  [data-search-banner='true'] & {
    --placeholderColour: ${brand.primary.purple.dark};
    --borderColour: ${brand.global.white};

    color: ${brand.primary.base};
  }

  &::placeholder {
    opacity: 0.75;
  }
`;
const ButtonWrapper = styled.div `
  position: absolute;
  top: 0;
  right: 0;

  button[data-icon-only='true'] {
    --buttonHeight: var(--inputHeight);

    border-radius: 0 6px 6px 0;
    border: 0;

    > div {
      --iconHeight: 22px;
    }
  }
`;
export default { Label, Container, Input, ButtonWrapper };
